export default {
  "indentZero": "bOLt2",
  "indentOne": "SDDve",
  "indentTwo": "boKgI",
  "indentThree": "samIr",
  "indentFour": "l3jBN",
  "indentFive": "abxX0",
  "indentSix": "_0kKPd"
};